export default "__VITE_ASSET__4vZANgoQ__"